enum StripeEnvironment {
  Uk = "Uk",
  It = "It",
}

export default StripeEnvironment;
